/**
 * Living Creatures Pack - Animals and wildlife from around the world
 * A comprehensive collection of creatures from land, sea, and air
 */

import { WordPack } from '../../types/GameTypes';

const livingCreaturesPack: WordPack = {
  id: 'living-creatures',
  name: 'Living Creatures',
  description: 'Animals and wildlife from around the world - mammals, birds, reptiles, fish, and more',
  difficulty: 'medium',
  words: [
    // Mammals - Large
    "ELEPHANT", "GIRAFFE", "RHINOCEROS", "HIPPOPOTAMUS", "BUFFALO", "CHEETAH",
    "LEOPARD", "JAGUAR", "PANTHER", "COUGAR", "BOBCAT", "LYNX", "TIGER",
    "LION", "ZEBRA", "ANTELOPE", "GAZELLE", "WILDEBEEST", "BISON", "MOOSE",
    "REINDEER", "CARIBOU", "DEER", "ELK", "PUMA", "COYOTE", "WOLF", "HYENA",
    "KANGAROO", "WALLABY", "KOALA", "WOMBAT", "OPOSSUM", "SLOTH", "LLAMA",
    "ALPACA", "CAMEL", "AARDVARK", "ANTEATER",
    
    // Mammals - Medium
    "HORSE", "DONKEY", "MULE", "PONY", "SHEEP", "GOAT", "PIG", "BOAR",
    "BEAR", "PANDA", "BADGER", "WOLVERINE", "OTTER", "SEAL", "WALRUS",
    "DOLPHIN", "WHALE", "ORCA", "PORPOISE", "MANATEE", "DUGONG",
    "MONKEY", "CHIMPANZEE", "GORILLA", "ORANGUTAN", "BABOON", "LEMUR",
    "RACCOON", "SKUNK", "PORCUPINE", "ARMADILLO", "BEAVER", "MUSKRAT",
    
    // Mammals - Small
    "DOG", "CAT", "RABBIT", "HARE", "SQUIRREL", "CHIPMUNK", "HAMSTER",
    "GERBIL", "GUINEA", "FERRET", "MINK", "WEASEL", "VOLE", "SHREW",
    "MOUSE", "RAT", "MOLE", "HEDGEHOG", "BAT", "PIKA",
    
    // Birds - Large
    "EAGLE", "HAWK", "FALCON", "VULTURE", "CONDOR", "ALBATROSS", "PELICAN",
    "CRANE", "HERON", "STORK", "FLAMINGO", "SWAN", "GOOSE",
    "OSTRICH", "EMU", "TURKEY", "PEACOCK", "PHEASANT",
    
    // Birds - Medium
    "DUCK", "CHICKEN", "ROOSTER", "PIGEON", "DOVE", "CROW", "RAVEN",
    "MAGPIE", "JAY", "CARDINAL", "ROBIN", "THRUSH", "BLACKBIRD", "STARLING",
    "SPARROW", "FINCH", "CANARY", "PARROT", "MACAW", "COCKATOO", "TOUCAN",
    "WOODPECKER", "KINGFISHER", "SWALLOW", "SWIFT", "LARK",
    
    // Birds - Small/Water
    "PENGUIN", "PUFFIN", "TERN", "GULL", "SEAGULL",
    "SANDPIPER", "HUMMINGBIRD", "WREN",
    
    // Reptiles
    "SNAKE", "PYTHON", "COBRA", "VIPER", "ADDER", "MAMBA", "ANACONDA",
    "TURTLE", "TORTOISE", "TERRAPIN", "LIZARD", "IGUANA", "GECKO", "SKINK",
    "MONITOR", "CHAMELEON", "CROCODILE", "ALLIGATOR",
    
    // Amphibians
    "FROG", "TOAD", "NEWT", "SALAMANDER", "TADPOLE",
    
    // Fish - Ocean
    "SHARK", "TUNA", "SALMON", "MARLIN", "SWORDFISH", "BARRACUDA",
    "MANTA", "STINGRAY", "GROUPER", "SNAPPER", "MACKEREL", "SARDINE",
    "ANCHOVY", "HERRING", "COD", "HALIBUT", "FLOUNDER", "SOLE", "POLLOCK",
    "HADDOCK", "BASS", "BLUEFISH", "POMPANO", "MAHIMAHI",
    
    // Fish - Freshwater
    "TROUT", "PIKE", "PERCH", "CATFISH", "CARP", "GOLDFISH", "GUPPY",
    "TETRA", "ANGELFISH", "MOLLY", "SUNFISH", "CRAPPIE",
    
    // Marine Life
    "OCTOPUS", "SQUID", "CUTTLEFISH", "JELLYFISH", "STARFISH", "URCHIN",
    "ANEMONE", "CORAL", "SPONGE", "CRAB", "LOBSTER", "SHRIMP", "PRAWN",
    "BARNACLE", "MUSSEL", "OYSTER", "CLAM", "SCALLOP", "CONCH", "ABALONE",
    
    // Insects
    "BUTTERFLY", "MOTH", "BEETLE", "LADYBUG", "FIREFLY", "DRAGONFLY",
    "GRASSHOPPER", "CRICKET", "LOCUST", "MANTIS", "CICADA", "APHID",
    "ANT", "TERMITE", "BEE", "WASP", "HORNET", "FLY", "MOSQUITO",
    "GNAT", "TICK", "FLEA", "LOUSE", "WEEVIL", "GRUB",
    
    // Arachnids
    "SPIDER", "TARANTULA", "WIDOW", "SCORPION", "MITE",
    
    // Other Invertebrates
    "WORM", "EARTHWORM", "LEECH", "SLUG", "SNAIL", "CENTIPEDE", "MILLIPEDE",
    
    // Aquatic Creatures
    "SEAHORSE", "ANGLERFISH",
    "PARROTFISH", "SURGEONFISH", "PUFFERFISH",
    
    // Extinct/Mythical (commonly known)
    "DINOSAUR", "MAMMOTH", "DODO", "SABRE", "DRAGON"
  ]
};

export default livingCreaturesPack;